export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_ACTIVITY_FILTERS': {
      return {
        ...state,
        activityFilters: action.data,
      };
    }
    case 'SET_ACTIVITY_FILTER_FLAG': {
      return {
        ...state,
        activeFilter: action.data,
      };
    }
    case 'SET_TAG': {
      return {
        ...state,
        tag: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
